
import {
  required,
  minLength,
  email,
} from 'vuelidate/lib/validators';
import errorParseNetwork from "~/helpers/errorParseNetwork";

export default {
  name: 'PopUpSendPresentation',

  data() {
    return {
      form: {
        name: '',
        phone: '',
        email: '',
      },
      consentPersonalInfo: true,
    };
  },

  validations() {
    const form = {
      email: {
        required,
        email,
      }
    };

    return {
      form,
    };
  },

  computed: {
    isOpen() {
      return this.$store.state['pop-up-send-presentation']?.isOpen || false;
    },
    settings() {
      return this.$store.state['pop-up-send-presentation']?.settings || {};
    },

    title() {
      return this.settings.title || 'Укажите почту, на которую выслать презентацию';
    },
    subtitle() {
      return this.settings.subtitle || 'Отправим на указанные данные презентацию "ЖК 9космонавтов"'
    },
    message() {
      return this.settings.message || '';
    },
    formType() {
      return this.settings.formType || 'Отправить презентацию';
    },
    additionalData() {
      return this.settings?.additional_data || null;
    },
    errorEmail: function () {
      const error = this.$v?.form?.email;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }

      if (!error.required) {
        return "Обязательно к заполнению"
      }
      if (!error.email) {
        return "Неправильный формат ввода"
      }

      return null
    },
    path() {
      if (!process.client) {
        return String(this.$route.path);
      }
      return String(window.location);
    },
  },

  methods: {
    close() {
      this.form = {
        name: '',
        phone: '',
        email: '',
      };
      this.$v.$reset();
      this.$store.commit('pop-up-send-presentation/setOpen', false);
    },

    async submitForm() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return null;
      }

      this.$store.commit('loading/setLoading', { name: 'popUpLoading', value: true });

      const body = {
        email: this.form.email,
        type: this.formType,
        name: this.form.name,
        phone: (this.form?.phone || '').replace(/[^\d]/g, ''),
        url: window.location.href,
      };
      if (this.message) {
        body.message = this.message;
      }
      if (this.additionalData) {
        body.additional_data = this.additionalData;
      }
      body.source = this.$cookies.get('sbjs_current') || '';
      const response = await this.$api.agent.transport.post('/presentation-form/send', body).then((res) => res.data).catch((err) => ({
        error: errorParseNetwork(err.response),
      }));
      if (response.error) {
        this.$store.commit('loading/setLoading', { name: 'popUpLoading', value: false });

        this.$toast.error(response.error);

        return;
      }

      if (this.settings?.reachGoal) {
        this.$yandexMetrika.reachGoal(this.settings?.reachGoal);
      }

      this.$store.commit('loading/setLoading', { name: 'popUpLoading', value: false });
      this.$store.commit('pop-up-success-form/setOpen', {
        open: true,
        settings: {
          title: 'Спасибо!',
          message: 'Мы отправили презентацию на вашу почту',
        },
      });
      this.close();
    },
  },
};
